import { render, staticRenderFns } from "./student-tag-list.vue?vue&type=template&id=d27989a8&scoped=true"
import script from "./student-tag-list.vue?vue&type=script&lang=js"
export * from "./student-tag-list.vue?vue&type=script&lang=js"
import style0 from "./student-tag-list.vue?vue&type=style&index=0&id=d27989a8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d27989a8",
  null
  
)

export default component.exports